import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";

import classes from "./RankingItem.module.css";

function RankIcon({ rank, matchIndex }) {
  let cssCls = classes.rankIcon;
  if (rank - 1 === matchIndex) {
    cssCls += ` ${classes.active_icon}`;
  }
  return <span className={cssCls}>{rank}</span>;
}

export default function RankingItem({
  ranking,
  name,
  pIndex,
  rankMatchesIndices = [],
  onRankChange = () => {},
}) {
  const indiceItem = rankMatchesIndices.find(
    (item) =>
      item.name.toString().toLowerCase().trim() ===
      name.toString().toLowerCase().trim()
  );

  let matchIndex = -1;
  if (indiceItem) {
    matchIndex = indiceItem.indices[pIndex];
  }

  return (
    <List dense>
      <Typography className="ps-3" variant="body2">{`Set ${
        pIndex + 1
      }`}</Typography>

      {ranking.map((item, index) => (
        <ListItem
          key={item}
          className={classes.list_item}
          onClick={() => {
            onRankChange({
              index,
              pIndex,
              name,
            });
          }}
        >
          <ListItemIcon
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              minWidth: "35px",
              height: "40px",
            }}
          >
            <RankIcon
              rank={index + 1}
              matchIndex={matchIndex}
              sx={{ fontSize: "26px" }}
            />
          </ListItemIcon>

          <ListItemText
            primary={item}
            className={index === matchIndex ? classes.active_text : ""}
          />
          {index === matchIndex && (
            <CancelIcon
              title="Remove ranking"
              className={classes.removeBtn}
              onClick={(e) => {
                e.stopPropagation();
                onRankChange({
                  index: -1,
                  pIndex,
                  name,
                });
              }}
            />
          )}
        </ListItem>
      ))}
    </List>
  );
}
